const imgUrl = {
    'logo': require('./logo.png'),
    'longlogo': require('./long-logo.png'),
    'poweredby': require('./powered-by.png'),
    'stoptblogo': require('./stoptb_logo.png'),
    'mapdefult': require('./marker/default_nearme.svg'),
    'accessbility': require('./services/hospital.svg'),
    'tour-guide': require('./tour-guide.png'),
    'microphone': require('./microphone-black-shape.svg'),
    'micicon': require('./mic.png'),
    'settings': require('./settings.png'),
    'neame': require('./neame.png'),
    'langicon': require('./language.png'),
    'qaulity': require('./services/unacceptable.svg'),
    'newmarker': require('./markernew.png'),
    // 'logout': require('../../../assets/images/dpcb-images/home-logout.png'),
    // 'dohlogo': require('../../../assets/images/dpcb-images/doh.png'),
    // 'homesvg': require('../../../assets/images/dpcb-images/homenav.png'),
    // 'journeysvg': require('../../../assets/images/dpcb-images/home-journeyicon.png'),
    // 'nearsvg': require('../../../assets/images/dpcb-images/home-nearicon.png'),
    // 'guidesvg': require('../../../assets/images/dpcb-images/home-guideicon.png'),
    // 'connectsvg': require('../../../assets/images/dpcb-images/home-connecticon.png'),
    // 'clients': require('../../../assets/images/dpcb-images/home-clients.png'),
    // 'tasks': require('../../../assets/images/dpcb-images/home-task.png'),
    // 'refer': require('../../../assets/images/dpcb-images/home-refer.png'),
    // 'notify': require('../../../assets/images/dpcb-images/home-pronotify.png'),
    // 'education': require('../../../assets/images/dpcb-images/home-educate.png'),
    // 'groupuser': require('../../../assets/images/dpcb-images/Groupuser.png'),
    // //'beneficiary': require('../../../assets/images/dpcb-images/Beneficiary.png'),
    // 'provider': require('../../../assets/images/dpcb-images/Provider.png'),
    // 'userpass': require('../../../assets/images/dpcb-images/userpass.png'),
    // 'back': require('../../../assets/images/back.png'),
    // 'qrcode': require('../../../assets/images/dpcb-images/scanimg.png'),
    // 'screensvg': require('../../../assets/images/dpcb-images/home-screeningicon.png'),
    // 'journey': require('../../../assets/images/dpcb-images/home-journey.png'),
    // 'nearrme': require('../../../assets/images/dpcb-images/home-nearme.png'),
    // 'disease': require('../../../assets/images/dpcb-images/home-disease.png'),
    // 'screening': require('../../../assets/images/dpcb-images/home-screening.png'),
    // // 'connected': require('../../../assets/images/dpcb-images/home-connect.png'),
    // 'connected': require('../../../assets/images/dpcb-images/home/home-connected.png'),
    // 'america': require('../../../assets/images/dpcb-images/english.png'),
    // 'bisaya': require('../../../assets/images/dpcb-images/bisaya.png'),
    // //'connect': require('../../../assets/images/dpcb-images/Connect.png'),
    // 'eduuser': require('../../../assets/images/dpcb-images/edu-home.png'),
    // 'logoutedu': require('../../../assets/images/dpcb-images/edu-back.png'),
    // 'mytraining': require('../../../assets/images/dpcb-images/Mytrainings2x.png'),
    // 'omiguide': require('../../../assets/images/dpcb-images/omeguide.png'),
    // //'govissue': require('../../../assets/images/dpcb-images/Dpcb-new/answers.png'),
    // 'openeducate': require('../../../assets/images/dpcb-images/openeducate.png'),
    // 'knowavatar': require('../../../assets/images/dpcb-images/diseaseavatar.png'),
    // 'knowavatar1': require('../../../assets/images/dpcb-images/Dpcb-new/girl-avtar.png'),
    // 'clientproavatar': require('../../../assets/images/dpcb-images/clientproavatar.png'),
    // 'clientbirth': require('../../../assets/images/dpcb-images/clientbirth.png'),
    // 'clientbot': require('../../../assets/images/dpcb-images/clientbot.png'),
    // 'clientdate': require('../../../assets/images/dpcb-images/clientdate.png'),
    // 'clientdia': require('../../../assets/images/dpcb-images/clientdia.png'),
    // 'clienthos': require('../../../assets/images/dpcb-images/clienthos.png'),
    // 'clientremark': require('../../../assets/images/dpcb-images/clientremark.png'),
    // 'clienttreat': require('../../../assets/images/dpcb-images/clienttreat.png'),
    // 'clienttaskdone': require('../../../assets/images/dpcb-images/clienttaskdone.png'),
    // 'clientgender': require('../../../assets/images/dpcb-images/clientgender.png'),
    // 'whiteback': require('../../../assets/images/dpcb-images/whiteback.png'),
    // 'covid': require('../../../assets/images/dpcb-images/covid-19.png'),
    // 'tbtreat': require('../../../assets/images/dpcb-images/tb-treat.png'),
    // //'provnotify': require('../../../assets/images/dpcb-images/Dpcb-new/Notifications.png'),
    // 'addclient': require('../../../assets/images/dpcb-images/edu-home.png'),
    // 'omnibus': require('../../../assets/images/dpcb-images/omeguide.png'),
    // 'ontraining': require('../../../assets/images/dpcb-images/ontraining.png'),
    // 'comtraining': require('../../../assets/images/dpcb-images/comtraining.png'),
    // //'govissue': require('../../../assets/images/dpcb-images/Dpcb-new/answers.png'),
    // //'diseaseadvi': require('../../../assets/images/dpcb-images/Dpcb-new/Disease-advisories.png'),
    // 'trainfilter': require('../../../assets/images/dpcb-images/trainfilter.png'),
    // 'getconnected': require('../../../assets/images/dpcb-images/get-connected.png'),
    // 'history': require('../../../assets/images/dpcb-images/history.png'),
    // 'journeycerti': require('../../../assets/images/dpcb-images/certify.png'),


}

export default imgUrl;